import React from 'react';
import { Circle, G, Line, Path, Polygon, Rect, Text as SvgText } from 'react-native-svg';
import { DiagramCanvas } from '../DiagramCanvas';
import { FormulaTag } from '../FormulaTag';
import { LeaderLine } from '../LeaderLine';
import { DT } from '../tokens';

/** Mixed-air state on psychrometric chart — saturation curve + 100/80/60% RH lines + 1→2 mix line. */
export function DiagramMixedAirPsych() {
  return (
    <DiagramCanvas>
      {/* Axes */}
      <Line x1={40} y1={210} x2={325} y2={210} stroke={DT.dim} strokeWidth="1.4" />
      <Line x1={40} y1={28} x2={40} y2={210} stroke={DT.dim} strokeWidth="1.4" />
      {/* Axis ticks */}
      {[0, 1, 2, 3, 4, 5].map(i => (
        <Line key={`tx${i}`} x1={40 + i * 55} y1={210} x2={40 + i * 55} y2={214} stroke={DT.dim} strokeWidth="1" />
      ))}
      {[0, 1, 2, 3].map(i => (
        <Line key={`ty${i}`} x1={36} y1={210 - i * 50} x2={40} y2={210 - i * 50} stroke={DT.dim} strokeWidth="1" />
      ))}
      <SvgText x={180} y={228} fill={DT.dim} fontSize="9" fontFamily={DT.mono} textAnchor="middle">Dry-bulb (°F)  →</SvgText>
      <SvgText x={28} y={120} fill={DT.dim} fontSize="9" fontFamily={DT.mono} textAnchor="middle"
        rotation="-90" originX="28" originY="120">Humidity ratio  ↑</SvgText>

      {/* Saturation curve (100% RH) */}
      <Path d="M50,205 Q90,200 130,180 Q180,150 220,110 Q260,70 300,40"
        fill="none" stroke={DT.stroke} strokeWidth="2" />
      <SvgText x={296} y={36} fill={DT.desc} fontSize="8" fontFamily={DT.mono} textAnchor="end">100% RH</SvgText>

      {/* 60% RH curve */}
      <Path d="M50,208 Q100,205 150,195 Q210,180 270,150"
        fill="none" stroke={DT.dim} strokeWidth="1" strokeDasharray="3,3" />
      <SvgText x={272} y={148} fill={DT.dim} fontSize="7" fontFamily={DT.mono}>60%</SvgText>

      {/* 30% RH */}
      <Path d="M50,209 Q120,207 200,202 Q260,198 305,193"
        fill="none" stroke={DT.dim} strokeWidth="1" strokeDasharray="3,3" />
      <SvgText x={307} y={195} fill={DT.dim} fontSize="7" fontFamily={DT.mono}>30%</SvgText>

      {/* State 1 — RA (left/cool) */}
      <Circle cx={150} cy={170} r={5} fill={DT.leader} stroke={DT.stroke} strokeWidth="1" />
      <SvgText x={142} y={166} fill={DT.leader} fontSize="10" fontFamily={DT.mono} fontWeight="700" textAnchor="end">1·RA</SvgText>

      {/* State 2 — OA (right/hot/humid) */}
      <Circle cx={260} cy={90} r={5} fill={DT.varColor} stroke={DT.stroke} strokeWidth="1" />
      <SvgText x={268} y={88} fill={DT.varColor} fontSize="10" fontFamily={DT.mono} fontWeight="700">2·OA</SvgText>

      {/* Mixing line connecting states */}
      <Line x1={150} y1={170} x2={260} y2={90} stroke={DT.formula} strokeWidth="1.5" strokeDasharray="4,3" />

      {/* Mixed point M (proportional position — 60% closer to RA) */}
      <Circle cx={194} cy={138} r={5.5} fill={DT.formula} stroke={DT.varColor} strokeWidth="1.5" />
      <SvgText x={200} y={134} fill={DT.formula} fontSize="10" fontFamily={DT.mono} fontWeight="700">M</SvgText>

      {/* Tick marks on mix line showing fraction split */}
      <Line x1={172} y1={154} x2={176} y2={158} stroke={DT.dim} strokeWidth="1" />
      <Line x1={216} y1={122} x2={220} y2={126} stroke={DT.dim} strokeWidth="1" />

      {/* Labels */}
      <LeaderLine x1={150} y1={170} x2={70} y2={210} varName="State 1" desc="Return air" anchor="start" />
      <LeaderLine x1={260} y1={90} x2={310} y2={50} varName="State 2" desc="Outside air" anchor="end" />
      <LeaderLine x1={194} y1={138} x2={194} y2={45} varName="M" desc="Mixed air state" anchor="middle" />

      <FormulaTag formula="M lies on line 1→2; position by mass-flow ratio Q_OA/Q_total" />
    </DiagramCanvas>
  );
}
